import { useEffect, useContext } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

let skipNextNavigation = false;

export function useConfirmExit(shouldBlock, message) {
  const { navigator } = useContext(UNSAFE_NavigationContext);

  useEffect(() => {
    if (!shouldBlock) return;

    const originalPush = navigator.push;
    navigator.push = (...args) => {
      if (skipNextNavigation) {
        skipNextNavigation = false; // reset after use
        originalPush(...args);
        return;
      }
      if (window.confirm(message)) {
        originalPush(...args);
      }
    };

    return () => {
      navigator.push = originalPush;
    };
  }, [shouldBlock, message, navigator]);
}

export function bypassNextConfirm() {
  skipNextNavigation = true;
}
